import { Component } from '@angular/core';

@Component({
    templateUrl: './drop-add-help.component.html',
    standalone: false
})
export class DropAddHelpComponent{}

